// extracted by mini-css-extract-plugin
export default {"systemDetailsOverviewPopover":"SystemDetailsOverviewPopover_systemDetailsOverviewPopover__hWYuL","systemDetailsOverview":"SystemDetailsOverviewPopover_systemDetailsOverview__dU3oK"};